export let BaseSettings = null;
export function BaseGeneralSettingsInstanceCreator(settings) {
    BaseSettings = settings;
}
